export enum EventTypes {
  PAGE_VIEW = 'page_view'
}
